'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ButtonLink = require('../../01.atoms/ButtonLink/ButtonLink.js');
var GridTeaser = require('../GridTeaser/GridTeaser.js');
require('./_index.scss.js');

var _excluded = ["className", "headline", "items", "linkTitle", "link"];
var CLASSNAME = 'varta-category-overview',
    cnButtons = "".concat(CLASSNAME, "__buttons"),
    cnButton = "".concat(CLASSNAME, "__button");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function CategoryOverview(_ref) {
  var className = _ref.className,
      headline = _ref.headline,
      items = _ref.items,
      linkTitle = _ref.linkTitle,
      link = _ref.link,
      props = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var _useState = React.useState(items),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  React.useEffect(function () {
    // set 1st teaser as featured (md: 3)
    setData(items.map(function (a) {
      return (a.col = {
        md: 6,
        lg: 4
      }) && a;
    }));
  }, [items]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, /*#__PURE__*/React__default.createElement("h2", null, headline), /*#__PURE__*/React__default.createElement(GridTeaser, _rollupPluginBabelHelpers.extends({
    articles: true,
    data: data,
    fillLast: false
  }, props)), /*#__PURE__*/React__default.createElement("div", {
    className: cnButtons
  }, link && /*#__PURE__*/React__default.createElement(ButtonLink, {
    title: linkTitle,
    link: link,
    type: "secondary",
    className: cnButton,
    iconId: "caret-right-light",
    bold: true
  })), /*#__PURE__*/React__default.createElement("hr", {
    className: "small"
  }));
}
CategoryOverview.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Title */
  headline: PropTypes.string,

  /** Array of items */
  items: PropTypes.array.isRequired,

  /** URL to link to */
  link: PropTypes.string,

  /** Text to link */
  linkTitle: PropTypes.string
};

module.exports = CategoryOverview;
